import React from 'react'

import FormFrame from './components/FormFrame'
import Container from './components/Container'
import CustomRow from './components/Row'
import Column from './components/Column'
import Image from './components/Image'
import TextField from './components/TextField'
import TextArea from './components/TextArea'
import ButtonComponent from './components/Button'
import RadioButton from './components/RadioButton'
import TextComponent from './components/Text'
import CheckboxComponent from  './components/Checkbox'
import InputFile from './components/InputFile'
import DateField from './components/DateField'
import TableOfContents from './components/TableOfContents'

const RenderDOM = ({
  content,
  pageErrors,
  onChangeFormBuilderState,
  mode,
  formValues,
  onPatchFormValues,
  onClickSubmitForm,
  createSubmittedFormMedia,
  removeSubmittedFormMedia,
  uploadedMedia,
  currentPage,
  dom,
  findObjectAndPatch,
  data,
  isInputDisabled,
  togglePageSelection,
  currentLanguage
}) => {
  switch( content.type ) {
    case 'FormFrame': return <FormFrame
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      onClickSubmitForm={ onClickSubmitForm }
      createSubmittedFormMedia={ createSubmittedFormMedia }
      removeSubmittedFormMedia={ removeSubmittedFormMedia }
      uploadedMedia={ uploadedMedia }
      currentPage={ currentPage }
      dom={ dom }
      findObjectAndPatch={ findObjectAndPatch }
      togglePageSelection={ togglePageSelection }
      data={ data }
      currentLanguage={ currentLanguage } />
    case 'Container': return <Container
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      onClickSubmitForm={ onClickSubmitForm }
      createSubmittedFormMedia={ createSubmittedFormMedia }
      removeSubmittedFormMedia={ removeSubmittedFormMedia }
      uploadedMedia={ uploadedMedia }
      currentPage={ currentPage }
      dom={ dom }
      findObjectAndPatch={ findObjectAndPatch }
      togglePageSelection={ togglePageSelection }
      currentLanguage={ currentLanguage } />
    case 'Row': return <CustomRow
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      onClickSubmitForm={ onClickSubmitForm }
      createSubmittedFormMedia={ createSubmittedFormMedia }
      removeSubmittedFormMedia={ removeSubmittedFormMedia }
      uploadedMedia={ uploadedMedia }
      currentPage={ currentPage }
      dom={ dom }
      findObjectAndPatch={ findObjectAndPatch }
      isInputDisabled={ isInputDisabled }
      togglePageSelection={ togglePageSelection }
      currentLanguage={ currentLanguage } />
    case 'Col': return <Column
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      onClickSubmitForm={ onClickSubmitForm }
      createSubmittedFormMedia={ createSubmittedFormMedia }
      removeSubmittedFormMedia={ removeSubmittedFormMedia }
      uploadedMedia={ uploadedMedia }
      currentPage={ currentPage }
      dom={ dom }
      findObjectAndPatch={ findObjectAndPatch }
      data={ data }
      isInputDisabled={ isInputDisabled }
      togglePageSelection={ togglePageSelection }
      currentLanguage={ currentLanguage } />
    case 'Image': return <Image
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues } />
    case 'TextField': return <TextField
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      isInputDisabled={ isInputDisabled }
      currentLanguage={ currentLanguage } />
    case 'TextArea': return <TextArea
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      isInputDisabled={ isInputDisabled }
      currentLanguage={ currentLanguage } />
    case 'Button': return <ButtonComponent
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      onPatchFormValues={ onPatchFormValues }
      togglePageSelection={ togglePageSelection }
      onClickSubmitForm={ onClickSubmitForm }
      currentLanguage={ currentLanguage } />
    case 'Radio': return <RadioButton
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      createSubmittedFormMedia={ createSubmittedFormMedia }
      removeSubmittedFormMedia={ removeSubmittedFormMedia }
      uploadedMedia={ uploadedMedia }
      isInputDisabled={ isInputDisabled }
      currentLanguage={ currentLanguage } />
    case 'RadioFlexible': return <RadioButton
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      dom={ dom }
      findObjectAndPatch={ findObjectAndPatch }
      createSubmittedFormMedia={ createSubmittedFormMedia }
      removeSubmittedFormMedia={ removeSubmittedFormMedia }
      uploadedMedia={ uploadedMedia }
      isInputDisabled={ isInputDisabled }
      currentLanguage={ currentLanguage } />
    case 'Text': return <TextComponent
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      onPatchFormValues={ onPatchFormValues }
      currentLanguage={ currentLanguage } />
    case 'Checkbox': return <CheckboxComponent
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      createSubmittedFormMedia={ createSubmittedFormMedia }
      removeSubmittedFormMedia={ removeSubmittedFormMedia }
      uploadedMedia={ uploadedMedia }
      isInputDisabled={ isInputDisabled }
      togglePageSelection={ togglePageSelection }
      currentLanguage={ currentLanguage } />
    case 'CheckboxFlexible': return <CheckboxComponent
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      dom={ dom }
      findObjectAndPatch={ findObjectAndPatch }
      createSubmittedFormMedia={ createSubmittedFormMedia }
      removeSubmittedFormMedia={ removeSubmittedFormMedia }
      uploadedMedia={ uploadedMedia }
      isInputDisabled={ isInputDisabled }
      currentLanguage={ currentLanguage } />
    case 'InputFile': return <InputFile
      content={ content }
      pageErrors={ pageErrors }
      onChangeFormBuilderState={ onChangeFormBuilderState }
      mode={ mode }
      formValues={ formValues }
      onPatchFormValues={ onPatchFormValues }
      createSubmittedFormMedia={ createSubmittedFormMedia }
      removeSubmittedFormMedia={ removeSubmittedFormMedia }
      uploadedMedia={ uploadedMedia }
      isInputDisabled={ isInputDisabled }
      currentLanguage={ currentLanguage } />
    case 'DateField': return <DateField
      content={ content }
      pageErrors={ pageErrors }
      formValues={ formValues }
      onPatchFormFormValues={ onPatchFormValues }
      isInputDisabled={ isInputDisabled }
      currentLanguage={ currentLanguage } />
    case 'TableOfContents': return <TableOfContents
      onChangeFormBuilderState={ onChangeFormBuilderState }
      dom={ dom }
      formValues={ formValues }
      currentPage={ currentPage }
      isShowProgress={ currentPage === dom[0].children.length }
      currentLanguage={ currentLanguage }
    />
    default: return <div></div>
  }
}

export default RenderDOM
